var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageOptimizerImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "170px",
    height: "170px",
    viewBox: "0 0 170 170",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9985045%",
    y1: "100%",
    x2: "49.9985045%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42502%",
    y1: "45978%",
    x2: "42502%",
    y2: "16272%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60000%",
    y1: "82436%",
    x2: "60000%",
    y2: "33487%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61759%",
    y1: "47982%",
    x2: "61759%",
    y2: "13705%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Services",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-6",
    transform: "translate(-157.000000, -57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(157.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-Copy",
    fill: "#8A80FA",
    fillRule: "nonzero",
    x: 10,
    y: 10,
    width: 160,
    height: 160
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#3F3D56",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_fast_loading_0lbh",
    transform: "translate(11.000000, 25.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(8.000000, 0.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0468059701,
    y: 0,
    width: 48.902,
    height: 74.9081028,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#F2F2F2",
    x: 8,
    y: 0,
    width: 48,
    height: 73,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(13.000000, 14.000000)",
    fill: "#F9A826"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0272727273,
    y: 0.1395,
    width: 9.87121212,
    height: 8.796,
    rx: 4.398
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 26,
    y: 14,
    width: 26,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 26,
    y: 17,
    width: 21,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(13.000000, 28.000000)",
    fill: "#F9A826"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0272727273,
    y: 0.0213559322,
    width: 9.87121212,
    height: 8.94508475,
    rx: 4.47254237
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 26,
    y: 28,
    width: 26,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 26,
    y: 30,
    width: 26,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(13.000000, 41.000000)",
    fill: "#F9A826"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0272727273,
    y: 0.0533898305,
    width: 9.87121212,
    height: 8.94508475,
    rx: 4.47254237
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 26,
    y: 41,
    width: 26,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 26,
    y: 44,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(38.000000, 24.000000)",
    fill: "url(#linearGradient-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.0534545455,
    y: 0.106308725,
    width: 48.8990303,
    height: 43.8612081,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 39,
    y: 24,
    width: 47,
    height: 42,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(44.000000, 34.000000)",
    fill: "#F9A826"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.12,
    y: 0.0742857143,
    width: 9.81285714,
    height: 8.83142857,
    rx: 4.41571429
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 57,
    y: 34,
    width: 28,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 57,
    y: 37,
    width: 28,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 43,
    y: 48,
    width: 42,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 43,
    y: 51,
    width: 42,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 43,
    y: 55,
    width: 42,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#E0E0E0",
    x: 43,
    y: 58,
    width: 31,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(0.000000, 38.000000)",
    fill: "url(#linearGradient-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1867941,2.62726531 L88.1867941,2.62726531 L88.3594374,1.8602449 L88.1174416,2.60963265 C81.8237775,0.91689764 75.3359294,0.0456050364 68.8168047,0.0176326531 C21.8460191,-0.258612245 0,41.0796735 0,41.0796735 L44.5124628,64.466449 C44.5124628,64.466449 49.9721231,47.6066939 69.3627707,48.1562449 C70.6965633,48.1924276 72.0269767,48.3082273 73.3468471,48.5030204 L67.4474628,66.8013061 C66.7610148,67.7741992 66.6605347,69.0419658 67.1852203,70.1100459 C67.7099059,71.178126 68.7766368,71.8773151 69.9692777,71.9348571 C71.1619185,71.9923992 72.2915321,71.3991784 72.9174522,70.3866122 L72.9174522,70.3866122 L72.9174522,70.3777959 C73.2236315,69.8822597 73.3902945,69.3138233 73.3999682,68.7320816 C73.3999682,68.6336327 73.3999682,68.5351837 73.3896391,68.4382041 L77.6540764,49.4625306 C90.3588535,53.3534694 94.2086518,64.4649796 94.2086518,64.4649796 L139,42.1670204 C139,42.1670204 122.178344,11.8197551 88.1867941,2.62726531 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.8939153,38.0013309 C22.5538814,37.7308515 1,78.7786815 1,78.7786815 L44.9158305,102 C44.9158305,102 50.3039322,85.256884 69.4336102,85.7963647 C70.7810243,85.8328921 72.1249278,85.9523447 73.4577288,86.1540478 L88,40.5937943 C81.7707779,38.9010061 75.3479509,38.0295066 68.8939153,38.0013309 L68.8939153,38.0013309 Z",
    id: "Shape",
    fill: "#F9A826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6147007,41 L73,86.2632744 C88.9484292,88.6638666 93.5942501,102 93.5942501,102 L138,80.0055842 C138,80.0055842 121.315056,50.0679247 87.6147007,41 Z",
    id: "Shape",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3996029,105.533454 L88,40 L67.5956097,103.921964 C66.9148365,104.879229 66.8096257,106.133838 67.3213838,107.192029 C67.8331419,108.25022 68.8799335,108.94257 70.0497844,108.996599 C71.2196353,109.050628 72.3252453,108.457685 72.9314919,107.451128 L72.9314919,107.451128 L72.9314919,107.442338 C73.2301216,106.954911 73.3928092,106.395791 73.4025195,105.823522 C73.4112693,105.722438 73.4068944,105.628679 73.3996029,105.533454 Z",
    id: "Shape",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    transform: "translate(64.000000, 9.000000)",
    fill: "url(#linearGradient-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4504505,29.7564244 L14.0727928,29.6837791 L14.818018,26.8669186 C15.9913514,17.823314 11.5589189,16.9056105 9.89693694,16.8744767 C9.70579598,16.8025574 9.51089769,16.7416777 9.31315315,16.6921221 L9.31315315,15.6246802 C11.4504625,15.0822662 13.068646,13.2832615 13.4284685,11.0495058 L13.4428829,11.0495058 C13.7066667,11.0495058 13.9214414,10.6358721 13.9214414,10.1258721 C13.9317637,9.85553225 13.8585975,9.58877255 13.7124324,9.36383721 C13.7316517,9.16616279 13.7412613,8.96848837 13.7412613,8.77081395 C13.7422199,7.15773548 13.0997771,5.61487085 11.963964,4.50252907 C11.8872176,4.10814984 11.7500103,3.72882426 11.5574775,3.37875 C11.1495495,2.63747093 10.4706306,1.86950581 10.7473874,1.06744186 L8.95567568,1.2572093 L8.93837838,0.042994186 C8.3790991,0.146773256 8.14414414,0.81244186 7.81261261,1.28686047 C7.01405405,2.42843023 5.41261261,2.58706395 4.35315315,3.47659884 C3.99279279,3.77311047 3.1827027,4.69822674 3.33693694,5.30162791 C2.62534497,6.30847511 2.24277821,7.52161666 2.24432432,8.76636628 C2.24432432,8.9640407 2.25393393,9.16171512 2.27315315,9.35938953 C2.12698804,9.58432487 2.05382186,9.85108457 2.06414414,10.1214244 C2.06414414,10.6314244 2.27891892,11.0450581 2.5427027,11.0450581 L2.55711712,11.0450581 C2.91693955,13.2788138 4.53512305,15.0778185 6.67243243,15.6202326 L6.67243243,16.6876744 C6.4746879,16.73723 6.27978961,16.7981098 6.08864865,16.8700291 C4.42666667,16.9011628 -0.00576576577,17.812936 1.16756757,26.8624709 L1.91279279,29.6793314 L1.7354955,29.7134302 C1.20294943,29.8156414 0.731696595,30.1312646 0.425417226,30.5908597 C0.119137857,31.0504549 0.00292346008,31.6163702 0.102342342,32.1640988 L3.04720721,48.3521512 C3.10988206,48.697151 3.43242264,48.9247253 3.76792793,48.8606686 L4.28540541,48.7613372 L4.28540541,49.0756395 C3.69960535,49.3733195 3.32866187,49.9869764 3.32828829,50.6590116 L3.32828829,50.859157 L6.79927928,50.859157 L6.79927928,50.6590116 C6.79902791,50.0371148 6.48097631,49.4611289 5.9618018,49.1423547 L5.9618018,48.4381395 L6.43459459,48.3477035 C6.77002638,48.2832409 6.99128922,47.9514999 6.92900901,47.6064244 L4.17009009,32.398343 L11.8198198,32.398343 L9.06378378,47.607907 C9.00150357,47.9529825 9.22276641,48.2847234 9.5581982,48.349186 L10.030991,48.4396221 L10.030991,49.1438372 C9.51181648,49.4626115 9.19376488,50.0385973 9.19351351,50.6604942 L9.19351351,50.8606395 L12.6645045,50.8606395 L12.6645045,50.6604942 C12.6641309,49.988459 12.2931874,49.3748021 11.7073874,49.0771221 L11.7073874,48.7628198 L12.2248649,48.8621512 C12.5603701,48.9262079 12.8829107,48.6986336 12.9455856,48.3536337 L15.9207207,31.9624709 C16.0104343,31.4693696 15.9058919,30.9598127 15.6301199,30.5460345 C15.3543479,30.1322562 14.9299669,29.8481974 14.4504505,29.7564244 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FDB797",
    x: 69,
    y: 55,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FDB797",
    x: 74,
    y: 55,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#4D8AF0",
    x: 66,
    y: 37,
    width: 11,
    height: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.05,
    transform: "translate(66.000000, 37.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.108533333,
    y: 0.0592592593,
    width: 10.7785333,
    height: 3.90518519
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66,37.7699711 C66,37.7699711 70.1047904,39 71.5,39 C72.8952096,39 77,37.7699711 77,37.7699711 L77,37 L66,37 L66,37.7699711 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,37.0458305 C77,37.0458305 72.8952096,38 71.5,38 C70.1047904,38 66,37.0458305 66,37.0458305 L66,30.4861015 C66,27.4562113 68.4624339,25 71.5,25 L71.5,25 C74.5375661,25 77,27.4562113 77,30.4861015 L77,37.0458305 Z",
    id: "Shape",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,23 L74,23 L74,25.9412174 C74,26.5259669 73.4182505,27 72.7006261,27 L72.3010814,27 C71.583457,27 71.0017075,26.5259669 71.0017075,25.9412174 L71.0017075,23 L71,23 Z",
    id: "Shape",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3387763,55.5667491 L67.8931054,55.9880646 C67.4591104,56.0604492 67.0431075,55.7961854 66.9614212,55.3962166 L64.0452497,40.9740415 C63.9159085,40.3364541 64.0664303,39.6775656 64.4636765,39.1424356 C64.8609227,38.6073056 65.4723251,38.2398067 66.1632784,38.1208469 L66.793718,38.0119354 C67.227713,37.9395508 67.6437158,38.2038146 67.7254022,38.6037834 L70.9862968,54.7011893 C71.0256609,54.8953053 70.9794201,55.0958916 70.8578423,55.2584082 C70.7362645,55.4209249 70.5494124,55.5319207 70.3387763,55.5667491 L70.3387763,55.5667491 Z",
    id: "Shape",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6567341,55.5667146 L76.0868278,55.9880636 C76.5180585,56.0604541 76.9314117,55.7961692 77.0125778,55.3961685 L79.9595486,40.7320742 C80.1989933,39.5373706 79.3508965,38.3884371 78.064847,38.1652845 L77.1792128,38.0119364 C76.7479821,37.9395459 76.3346289,38.2038308 76.2534628,38.6038315 L73.0133379,54.702519 C72.9746794,54.8964342 73.0208422,55.0966638 73.1416036,55.2588679 C73.2623651,55.421072 73.4477602,55.5318658 73.6567341,55.5667146 L73.6567341,55.5667146 Z",
    id: "Shape",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,24.8432278 C71.9853072,25.0522574 73.0146928,25.0522574 74,24.8432278 L74,23 L71,23 L71,24.8432278 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#333333",
    cx: 71.5,
    cy: 17.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDB797",
    cx: 71.5,
    cy: 19.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0713579,13.0393155 C69.1640577,12.2525569 70.8162445,12.1121129 71.6384741,11.1017348 C71.9800394,10.6817666 72.2226898,10.0913567 72.7991778,10 L72.8161788,11.0744642 L74.6708319,10.9067496 C74.3849062,11.6157869 75.0850378,12.2975535 75.5069714,12.9520494 C75.8170505,13.435692 75.9864422,13.9795905 76,14.5351115 C75.3585991,14.8746312 74.5626438,14.5037502 73.8486024,14.3060379 C73.1345609,14.1083256 72.4158828,14.0933267 71.6848404,14.0756008 C71.3117563,14.0527088 70.936892,14.0710311 70.5689574,14.1301421 C70.2505302,14.205522 69.9402277,14.3054443 69.6416309,14.4287559 C69.1501478,14.6101058 67.5968758,15.295963 67.1409402,14.8541782 C66.6278196,14.3537616 67.6494243,13.3433834 68.0713579,13.0393155 Z",
    id: "Shape",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.889708,16.9428949 C69.2023931,17.0951575 69.5467626,17.1892262 69.901778,17.219354 C71.3673117,17.3972897 72.8596876,17.2486011 74.2443369,16.7866955 C74.4716634,17.2967625 75.0228523,17.6478655 75.612967,17.813741 C76.2030816,17.9796164 76.829008,17.9879102 77.4471492,17.996204 C77.5829886,18.0098026 77.7202882,17.986677 77.841078,17.9298538 C78.1166725,17.7653607 77.9827678,17.3866117 77.8223936,17.1295048 L77.0251939,15.8467346 C76.7900822,15.4679856 76.5471854,15.0809429 76.1828402,14.7948078 C75.7250732,14.435411 75.1178312,14.2667709 74.5199313,14.1603342 C73.1048502,13.910177 71.6438378,13.9532228 70.2505529,14.2861231 C68.7604745,14.6358438 66.8468836,15.8453523 68.889708,16.9428949 Z",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.889708,15.9428949 C69.2023931,16.0951575 69.5467626,16.1892262 69.901778,16.219354 C71.3673117,16.3972897 72.8596876,16.2486011 74.2443369,15.7866955 C74.4716634,16.2967625 75.0228523,16.6478655 75.612967,16.813741 C76.2030816,16.9796164 76.829008,16.9879102 77.4471492,16.996204 C77.5829886,17.0098026 77.7202882,16.986677 77.841078,16.9298538 C78.1166725,16.7653607 77.9827678,16.3866117 77.8223936,16.1295048 L77.0251939,14.8467346 C76.7900822,14.4679856 76.5471854,14.0809429 76.1828402,13.7948078 C75.7250732,13.435411 75.1178312,13.2667709 74.5199313,13.1603342 C73.1048502,12.910177 71.6438378,12.9532228 70.2505529,13.2861231 C68.7604745,13.6330792 66.8468836,14.8467346 68.889708,15.9428949 Z",
    id: "Shape",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    cx: 77.5,
    cy: 19,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    cx: 66.5,
    cy: 19,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,26.0309537 C71,26.0309537 63.698193,24.9296648 65.2047405,35.8649772 L66.0829054,39 L68.5964362,38.9026485 C68.5964362,38.9026485 66.9657831,35.2519669 67.9680535,32.8273059 C68.9703239,30.4026449 71,26.0309537 71,26.0309537 Z",
    id: "Shape",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,26.0309537 C73,26.0309537 80.301807,24.9296648 78.7952595,35.8649772 L77.9170946,39 L75.4035638,38.9026485 C75.4035638,38.9026485 77.0342169,35.2519669 76.0319465,32.8273059 C75.0296761,30.4026449 73,26.0309537 73,26.0309537 Z",
    id: "Shape",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDB797",
    cx: 67.5,
    cy: 39.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDB797",
    cx: 77.5,
    cy: 39.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3022049,56.0000126 L68.7029831,56.0000126 C69.4193058,56.0000126 70,56.7028578 70,57.5698614 L70,58 L67,58 L67,57.5698614 C66.9999972,57.1524214 67.1373588,56.7521696 67.3817199,56.4575846 C67.6260809,56.1629997 67.9573166,55.9983428 68.3022049,56.0000126 Z",
    id: "Shape",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3022049,56.0000126 L74.7029831,56.0000126 C75.4193058,56.0000126 76,56.7028578 76,57.5698614 L76,58 L73,58 L73,57.5698614 C72.9999972,57.1524214 73.1373588,56.7521696 73.3817199,56.4575846 C73.6260809,56.1629997 73.9573166,55.9983428 74.3022049,56.0000126 L74.3022049,56.0000126 Z",
    id: "Shape",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1374866,31 C68.1374866,31 67.6541353,33.09625 68.5,34",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3625134,31 C76.3625134,31 76.8458647,33.09625 76,34",
    id: "Shape",
    fill: "#000000",
    opacity: 0.1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOptimizerImage);
export default __webpack_public_path__ + "static/media/image-optimizer-image.5ab7a21dc5d5491bc8adf81441949b48.svg";
export { ForwardRef as ReactComponent };